import { useMembershipApi } from "../api/MembershipApiClient";
import { MembershipFrontendService } from "../services/MembershipFrontendService";

export const useMembershipService = (): MembershipFrontendService =>
  new MembershipFrontendService(useMembershipApi());
